import React from 'react';
import { HISTORY_RANGES, isRangeAvailable } from '../constants/historyRanges';

// Why a range is greyed out. Kept short: it sits in a title attribute.
const unavailableReason = (range) => `No readings older than ${range.unlocksAfterDays} days`;

// HistoryRangeSelector is the 7d/30d/1y/All switch shared by every chart that
// can widen its window. It is stateless: the caller owns the selected range and
// passes the device's firstReadingAt, which decides what is offered.
//
// It carries no outer spacing or alignment — callers sit it in the top right of
// the block it governs — and reads label-then-buttons so the buttons land on
// that edge.
//
// idPrefix names the test ids — buttons get `${idPrefix}-${key}` and the group
// gets `${idPrefix}s` — so two selectors on one page stay distinguishable.
const HistoryRangeSelector = ({ value, onChange, firstReadingAt, idPrefix }) => {
        const selected = HISTORY_RANGES.find((r) => r.key === value);

        return (
                <div className="flex items-center gap-2" data-testid={`${idPrefix}s`}>
                        <span className="text-xs text-gray-500">Showing {selected?.description}</span>
                        <div className="inline-flex rounded-md border border-gray-300 overflow-hidden" role="group" aria-label="History range">
                                {HISTORY_RANGES.map((range) => {
                                        // firstReadingAt is unknown until the first response lands, which
                                        // keeps every longer range disabled until we know it holds data.
                                        const available = isRangeAvailable(range, firstReadingAt);
                                        const isSelected = range.key === value;
                                        return (
                                                <button
                                                        key={range.key}
                                                        type="button"
                                                        data-testid={`${idPrefix}-${range.key}`}
                                                        onClick={() => onChange(range.key)}
                                                        disabled={!available}
                                                        aria-pressed={isSelected}
                                                        title={available ? `Show ${range.description}` : unavailableReason(range)}
                                                        className={`px-3 py-1 text-sm border-r border-gray-300 last:border-r-0 ${isSelected
                                                                ? 'bg-brand text-white'
                                                                : 'bg-white text-text-weak hover:bg-gray-50'
                                                                } disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-100`}
                                                >
                                                        {range.label}
                                                </button>
                                        );
                                })}
                        </div>
                </div>
        );
};

export default HistoryRangeSelector;
